import { render, staticRenderFns } from "./attrCard.vue?vue&type=template&id=c916300a&scoped=true"
import script from "./attrCard.vue?vue&type=script&lang=js"
export * from "./attrCard.vue?vue&type=script&lang=js"
import style0 from "./attrCard.vue?vue&type=style&index=0&id=c916300a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c916300a",
  null
  
)

export default component.exports